import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaSpinner, FaSearch, FaEye } from 'react-icons/fa';
import api from '../../services/api';
import './ContactsList.css';

function ContactsList() {
  const [contacts, setContacts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchContacts();
  }, []);

  useEffect(() => {
    filterContacts();
  }, [searchTerm, contacts]);

  const fetchContacts = async () => {
    try {
      const response = await api.get('/api/admin/contacts');
      setContacts(response.data);
      setFilteredContacts(response.data);
    } catch (error) {
      console.error('Error fetching contacts:', error);
    } finally {
      setLoading(false);
    }
  };

  const filterContacts = () => {
    if (!searchTerm.trim()) {
      setFilteredContacts(contacts);
      return;
    }

    const filtered = contacts.filter((contact) => {
      const search = searchTerm.toLowerCase();
      return (
        contact.name?.toLowerCase().includes(search) ||
        contact.email?.toLowerCase().includes(search) ||
        contact.phone?.includes(search) ||
        contact.subject?.toLowerCase().includes(search) ||
        contact.message?.toLowerCase().includes(search)
      );
    });

    setFilteredContacts(filtered);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const truncateText = (text, maxLength = 100) => {
    if (!text) return 'N/A';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  if (loading) {
    return (
      <div className="contacts-loading">
        <FaSpinner className="spinner" />
        <p>Loading contacts...</p>
      </div>
    );
  }

  return (
    <div className="contacts-list-page">
      <div className="contacts-header">
        <div className="contacts-title">
          <FaEnvelope />
          <h2>Contact Messages</h2>
          <span className="contacts-count">({contacts.length})</span>
        </div>

        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search by name, email, subject, or message..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {filteredContacts.length === 0 ? (
        <div className="no-contacts">
          <FaEnvelope />
          <p>{searchTerm ? 'No contacts found matching your search' : 'No contact messages yet'}</p>
        </div>
      ) : (
        <div className="contacts-grid">
          {filteredContacts.map((contact) => (
            <Link
              to={`/admin/dashboard/contacts/${contact._id}`}
              key={contact._id}
              className="contact-card"
            >
              <div className="contact-card-header">
                <div className="contact-avatar">
                  {contact.name.charAt(0).toUpperCase()}
                </div>
                <div className="contact-info">
                  <h3>{contact.name}</h3>
                  <p className="contact-date">{formatDate(contact.createdAt)}</p>
                </div>
              </div>

              <div className="contact-card-body">
                <h4 className="contact-subject">{contact.subject}</h4>
                <p className="contact-message-preview">{truncateText(contact.message)}</p>
              </div>

              <div className="contact-card-footer">
                <div className="contact-details">
                  <span className="contact-email">{contact.email}</span>
                  <span className="contact-phone">{contact.phone}</span>
                </div>
                <button className="view-btn">
                  <FaEye /> View
                </button>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default ContactsList;

